import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {formatLocaleDate} from '@/dayjs'
import {StyledActivityReportInfoBanner} from './style'

type ActivityReportExistingBannerProps = {
    createdAt: string
}

export const ActivityReportExistingBanner = ({createdAt}: ActivityReportExistingBannerProps) => {
    const {t} = useTranslation()

    return (
        <StyledActivityReportInfoBanner>
            <div className="banner-header">
                <AlertCircleIcon size={16} />
                {t('activity_report:existing_banner_title')}
            </div>
            <span>{t('activity_report:existing_banner_description', {date: formatLocaleDate(createdAt, 'lll')})}</span>
        </StyledActivityReportInfoBanner>
    )
}
